import React from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Content,
  AnimationContainer,
  Title,
  ColItem,
  Button,
} from './styles';

// import logoImg from '../../../assets/logo.png';
import { StoreState } from '../../../store/createStore';
import { routesEndpoints } from '../../../routes/endpoint';

const SummaryShow: React.FC = () => {
  const history = useHistory();
  const { order } = useSelector((state: StoreState) => state.checkout);
  return (
    <Container>
      <Content>
        <AnimationContainer>
          {/* <ColItem>
            <img src={logoImg} alt="ConectoVarejo" />
          </ColItem> */}

          <ColItem>
            <Title>
              <span>Pedido realizado com sucesso!</span>
              <p>
                Sua compra de número # <b>{order?.order_id}</b> foi realizada!
              </p>
              <p> Obrigado :)</p>
            </Title>
          </ColItem>
          <ColItem style={{ marginTop: '40px' }} />
          <ColItem>
            <Button
              type="track"
              onClick={() => history.push(routesEndpoints.ORDERS)}
            >
              <span>RASTREAR PEDIDO</span>
            </Button>
          </ColItem>
          <ColItem style={{ marginTop: '16px' }} />
          <ColItem>
            <Button
              type="buying"
              onClick={() => history.push(routesEndpoints.HOME)}
            >
              <span>CONTINUAR COMPRANDO</span>
            </Button>
          </ColItem>
          <ColItem style={{ marginTop: '16px' }} />
          <ColItem>
            <Button type="cancel">
              <span>CANCELAR PEDIDO</span>
            </Button>
          </ColItem>
        </AnimationContainer>
      </Content>
    </Container>
  );
};

export default SummaryShow;
